// File that contains action data
interface Action {
    id: string;
    description?: string;
    action: string | string[];
}

const actions: Record<string, Action> = {
    increment: {
        id: 'increment',
        description: 'Increment counter',
        action: '@counter = @counter + 1',
    },
    decrement: {
        id: 'decrement',
        description: 'Decrement counter',
        action: '@counter = @counter - 1',
    },
    attack: {
        id: 'attack',
        action: [
            'bool hit = (1d20 + @origin.strBonus + @origin.prof) >= @target.ac',
            'int damage = @origin.weapon.damage + @origin.strBonus if hit',
            '@target.hp = @target.hp - damage',
        ],
    },
};

export default actions;
